import { useTranslation } from "react-i18next";

import CarouselSwiper from "../CarouselSwiper/CarouselSwiper";

import "./PortfolioCardFullWeb.css";

const PortfolioCardFullWeb = ({ data }) => {
	const { t } = useTranslation();
	const slides = data["imagesCarousel"].map((image) =>
		require("../../assets/" + image)
	);

	return (
		<div className="portfolio-card-full-web-container">
			{slides.length === 1 ? (
				<div>
					<img
						className="portfolio-card-full-web-slider-simple"
						src={slides[0]}
						alt={data["altFixed"]}
					/>
				</div>
			) : (
				<div className="portfolio-card-full-web-slider">
					<CarouselSwiper
						slides={slides}
						alts={data["altsCarousel"]}
						key={data["id"]}
					/>
				</div>
			)}

			<div className="portfolio-card-full-web-container-data">
				<div>
					<div className="portfolio-card-full-web-title">
						<h3 className="text-bold">{data["title"]}</h3>
					</div>
					<div className="portfolio-card-full-web-subtitle ">
						<h3>{data["subtitle"]}</h3>
					</div>
					<hr className="portfolio-card-full-web-horizontal-line" />
					<div className="portfolio-card-full-web-description ">
						{data["paragraphs"].map((text, index) => {
							if (text["style"] === "br") {
								return <br key={index} />;
							} else if (text["style"] === "bold") {
								return (
									<h4 key={index} className="text-description">
										{text["text"]}
									</h4>
								);
							} else {
								return <h4 className="text-description">{text["text"]}</h4>;
							}
						})}
					</div>
				</div>
				<div>
					<div className="portfolio-card-full-grid">
						<h4 className="text">{t("portfolio.service")}</h4>
						<h4 className="text">{data["serviceType"]}</h4>
						<h4 className="text">{t("portfolio.year")}</h4>
						<h4 className="text">{data["year"]}</h4>
					</div>

					<hr className="portfolio-card-full-web-horizontal-line" />
					<div className="portfolio-card-full-web-tech-stack">
						<div className="portfolio-card-full-web-tech-stack-title">
							<h4 className="text">{t("portfolio.tech")}</h4>
						</div>
						<div className="portfolio-card-full-web-tech-stack-icons">
							{data["techStack"].map(function (tech, index) {
								return (
									<div
										key={index}
										className="portfolio-card-full-web-tech-stack-icon-container"
										title={tech["label"]}
									>
										<img
											key={index}
											alt={tech["label"]}
											src={require("../../assets/" + tech["image"])}
											className="portfolio-card-full-web-tech-stack-icon-image"
										/>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PortfolioCardFullWeb;
